<template>
    <div v-if="currentProject.meta" class="rendering">
        <transition name="animate-circle" mode="in-out">
            <div class="circle" :key=currentProject.meta.id>
                <div class="render-image">
                    <img :src=currentProject.meta.preview.foregroundImageUrl />        
                </div>
            </div>
        </transition>
        <transition name="slide-fade" mode="in-out">
            <div class="background" 
                :style="`background: url(${currentProject.meta.preview.backgroundImageUrl})`" 
                :key="currentProject.meta.preview.backgroundImageUrl"
            ></div>
        </transition>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    computed: {
      /* Using the namespace in mapState */
      ...mapState([
        'projects'
      ])
    },
    props: ['currentProject']
}
</script>

<style lang="scss">
    .rendering {
        width: 100%;
        height: 100%;

        background-size: cover;
        backdrop-filter: blur(3px);
    }
      /* prefix with transition name */
    .slide-fade-enter-active {
        transform: translateX(100%);
    }

    .slide-fade-leave-active {
        transform: translateX(-100%);
    }



    .circle {
        position: absolute;
        top: calc(50% - 15rem);
        left: calc(50% - 15rem);

        width: 30rem;
        height: 30rem;

        border-radius: 50%;

        background: rgb(240,247,253);
        background: linear-gradient(138deg, rgba(240,247,253,0) 16%, rgba(240,247,253,1) 100%);

        transition: all 420ms cubic-bezier(0, 0.55, 0.45, 1);


        .render-image {
            position: relative;
            left: -38%;
            top: -10%;

            width: 175%;

            transition: all 450ms cubic-bezier(0, 0.55, 0.45, 1);

        }
    }

    .animate-circle-enter-active {
        transform: translateX(150%);
        opacity: 0;
    }

    .animate-circle-leave-active {
        transform: translateX(-150%);
    }
</style>